import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 467C52AB-0DEA-43AF-BAE4-76FD66D6C7F0
 * name view-module
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-module.svg
 * tags
 * - View 
 */
export const ViewModuleIcon = createSvgIcon(<><path d="M16,5V11H21V5M10,11H15V5H10M16,18H21V12H16M10,18H15V12H10M4,18H9V12H4M4,11H9V5H4V11Z" /></>, 'ViewModuleIcon');
export default ViewModuleIcon